export interface PatientDetails {
  name: string;
  phone: string;
  patientBalance: number;
  insuranceBalance: number;
  totalBalance: number;
  photoUrl: string | undefined;
}

export type BalanceFilterType =
  | 'BY_ALL'
  | 'BY_PATIENT_BAL'
  | 'BY_INSURANCE_BAL';

export enum CardStatus {
  VALID_CARD = 'VALID_CARD',
  NO_CARD = 'NO_CARD',
  CARD_DECLINED = 'CARD_DECLINED',
  EXPIRED_CARD = 'EXPIRED_CARD',
  CONSENT_PENDING = 'CONSENT_PENDING',
}

export const getCardStatusText = (status: CardStatus | undefined) => {
  switch (status) {
    case CardStatus.VALID_CARD:
      return 'Active';
    case CardStatus.NO_CARD:
      return 'Card not available';
    case CardStatus.CARD_DECLINED:
      return "Patient's card is declined";
    case CardStatus.EXPIRED_CARD:
      return 'Expired card';
    case CardStatus.CONSENT_PENDING:
      return 'Consent Pending';
    default:
      return 'N/A';
  }
};

export enum PaymentPlanStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export interface PaymentPlan {
  id: string;
  clientId: string;
  status: PaymentPlanStatus;
  card_status: CardStatus;
  paymentAmount: number;
  frequency: string;
  nextPaymentDate: string;
  totalPaid: number;
  currentBalance: number;
  consecutiveFailures: number;
  maxFailures: number;
  autoPauseOnFailure: boolean;
  estimatedPaymentsRemaining: number;
  estimatedCompletionDate: string;
  createdAt: string;
  pausedAt: string | null;
  completedAt: string | null;
  cancelledAt: string | null;
  cancellationReason: string | null;
  last_payment_date: string;
}

export interface LedgerEntry {
  cptCode: string;
  serviceDate: string;
  provider: string | null;
  chargeAmt: number;
  appliedAmt: number;
  patientBal: number;
  insuranceBal: number;
  totalBal: number;
  details?: LedgerEntryDetail[];
  isExpanded?: boolean;
}

export interface LedgerEntryDetail {
  type: 'PI' | 'PP' | 'WOINS';
  serviceDate: string;
  appliedAmt: number;
}

export interface ClientBalance {
  client_id: string;
  ehr_user_id: string;
  client_name: string;
  total_balance_amount: string;
  patient_balance_amount: string;
  insurance_balance_amount: string;
  latest_charge_date: string;
  proto_account: boolean;
}

export interface Payment {
  id: string;
  ehr_payment_id: string;
  type: string;
  code: string;
  amount: number;
  service_date: string;
  carrier?: string;
}

export interface Charge {
  id: string;
  ehr_charge_id: string;
  type: string;
  code: string;
  charge_amount: number;
  applied_amount: number;
  patient_balance: number;
  insurance_balance: number;
  total_balance: number;
  service_date: string;
  visit_id: string;
  provider_name: string;
  responsible_party_name: string;
  total_visit_charge: number;
  description: string;
  payments: Payment[];
}

export interface TransactionLedgerResponse {
  client_balance: ClientBalance;
  charges: Charge[];
}

export enum PatientDetailsTabName {
  HOME = 'home',
  PATIENT_LEDGER = 'patientLedger',
  MANAGE_CARDS = 'manageCards',
}

export enum PatientDetailsModalMode {
  CREATE = 'create',
  EDIT = 'edit',
}

export enum PaymentPlanActionType {
  WOINS = 'WOINS',
  PP = 'PP',
  PI = 'PI',
  PATIENT_PAYMENT = 'PATIENT_PAYMENT',
  INSURANCE_PAYMENT = 'INSURANCE_PAYMENT',
  INSURANCE_WRITE_OFF = 'INSURANCE_WRITE_OFF',
  payment = 'payment',
  adjustment = 'adjustment',
}
